import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-820192ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "ai-assistant-widget"
}
const _hoisted_2 = {
  key: 0,
  class: "ai-assistant-widget__panel"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Pergunte ao Fluxoo", -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M9.29404 7.89904L15.5 1.68604C15.6857 1.50039 15.79 1.24859 15.79 0.986043C15.79 0.723492 15.6857 0.471695 15.5 0.286043C15.3144 0.100392 15.0626 -0.00390625 14.8 -0.00390625C14.5375 -0.00390625 14.2857 0.100392 14.1 0.286043L7.90004 6.49904L1.68604 0.289043C1.50039 0.103392 1.24859 -0.00090625 0.986043 -0.00090625C0.723492 -0.00090625 0.471695 0.103392 0.286043 0.289043C0.100392 0.474695 -0.00390625 0.726492 -0.00390625 0.989043C-0.00390625 1.25159 0.100392 1.50339 0.286043 1.68904L6.50004 7.89904L0.289043 14.107C0.103392 14.2927 -0.00090625 14.5445 -0.00090625 14.807C-0.00090625 15.0696 0.103392 15.3214 0.289043 15.507C0.474695 15.6927 0.726492 15.797 0.989043 15.797C1.25159 15.797 1.50339 15.6927 1.68904 15.507L7.90004 9.29304L14.108 15.499C14.2937 15.6847 14.5455 15.789 14.808 15.789C15.0706 15.789 15.3224 15.6847 15.508 15.499C15.6937 15.3134 15.798 15.0616 15.798 14.799C15.798 14.5365 15.6937 14.2847 15.508 14.099L9.29404 7.89904Z",
    fill: "#6F6F6F"
  })
], -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 0,
  class: "ai-assistant-widget__empty"
}
const _hoisted_8 = {
  key: 0,
  class: "ai-assistant-widget__sources"
}
const _hoisted_9 = {
  key: 1,
  class: "ai-assistant-widget__message assistant"
}
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["disabled"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M4 20L21 12L4 4L4 10L15 12L4 14L4 20Z",
    fill: "currentColor"
  })
], -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "26",
  height: "26",
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M12 3L13.7 8.3L19 10L13.7 11.7L12 17L10.3 11.7L5 10L10.3 8.3L12 3Z",
  fill: "currentColor"
}, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M19 15L19.8 17.2L22 18L19.8 18.8L19 21L18.2 18.8L16 18L18.2 17.2L19 15Z",
  fill: "currentColor"
}, null, -1))
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 16 16",
  fill: "none"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M9.29404 7.89904L15.5 1.68604C15.6857 1.50039 15.79 1.24859 15.79 0.986043C15.79 0.723492 15.6857 0.471695 15.5 0.286043C15.3144 0.100392 15.0626 -0.00390625 14.8 -0.00390625C14.5375 -0.00390625 14.2857 0.100392 14.1 0.286043L7.90004 6.49904L1.68604 0.289043C1.50039 0.103392 1.24859 -0.00090625 0.986043 -0.00090625C0.723492 -0.00090625 0.471695 0.103392 0.286043 0.289043C0.100392 0.474695 -0.00390625 0.726492 -0.00390625 0.989043C-0.00390625 1.25159 0.100392 1.50339 0.286043 1.68904L6.50004 7.89904L0.289043 14.107C0.103392 14.2927 -0.00090625 14.5445 -0.00090625 14.807C-0.00090625 15.0696 0.103392 15.3214 0.289043 15.507C0.474695 15.6927 0.726492 15.797 0.989043 15.797C1.25159 15.797 1.50339 15.6927 1.68904 15.507L7.90004 9.29304L14.108 15.499C14.2937 15.6847 14.5455 15.789 14.808 15.789C15.0706 15.789 15.3224 15.6847 15.508 15.499C15.6937 15.3134 15.798 15.0616 15.798 14.799C15.798 14.5365 15.6937 14.2847 15.508 14.099L9.29404 7.89904Z",
  fill: "#FFF"
}, null, -1))
const _hoisted_20 = [
  _hoisted_19
]

import { computed, nextTick, onMounted, ref } from 'vue'
import { useAxios } from '@/api/axios'
import { user, hasAiModule } from '@/global/states/GlobalState'
import SpinnerLoaderButton from '@/components/loader/SpinnerLoaderButton.vue'

interface AiSource {
  id: number
  number: number
  title: string
}

interface AiMessage {
  role: 'user' | 'assistant'
  text: string
  sources?: AiSource[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AiAssistantWidget',
  setup(__props) {

const axios = useAxios()
const isOpen = ref(false)
const question = ref('')
const isAsking = ref(false)
const messages = ref<AiMessage[]>([])
const aiUsage = ref<{ limit: number, used: number, remaining: number }>()
const messagesEl = ref<HTMLElement>()

const canUseAi = computed(() => hasAiModule.value && (user.value.can?.('create_documents') ?? false))

function getAiUsage (): void {
  axios.get('/api/documents/ai-generate-content/usage')
    .then((res) => {
      aiUsage.value = res.data
    })
}

function scrollToBottom (): void {
  nextTick(() => {
    if (messagesEl.value) {
      messagesEl.value.scrollTop = messagesEl.value.scrollHeight
    }
  })
}

function ask (): void {
  const currentQuestion = question.value.trim()
  if (!currentQuestion || isAsking.value) return

  messages.value.push({ role: 'user', text: currentQuestion })
  question.value = ''
  isAsking.value = true
  scrollToBottom()

  const body = new FormData()
  body.append('question', currentQuestion)

  axios.post('/api/ai/ask', body)
    .then((res) => {
      messages.value.push({ role: 'assistant', text: res.data.answer, sources: res.data.sources })
    })
    .catch((error) => {
      if (!error?.response?.data?.errors) {
        messages.value.push({ role: 'assistant', text: 'Não foi possível obter uma resposta agora. Tente novamente.' })
      }
    })
    .finally(() => {
      isAsking.value = false
      getAiUsage()
      scrollToBottom()
    })
}

onMounted(() => {
  if (canUseAi.value) {
    getAiUsage()
  }
})

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (canUseAi.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (isOpen.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("header", null, [
                _createElementVNode("div", null, [
                  _hoisted_3,
                  (aiUsage.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(aiUsage.value.remaining) + " de " + _toDisplayString(aiUsage.value.limit) + " perguntas restantes hoje", 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "ai-assistant-widget__close",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (isOpen.value = false))
                }, _hoisted_6)
              ]),
              _createElementVNode("div", {
                class: "ai-assistant-widget__messages",
                ref_key: "messagesEl",
                ref: messagesEl
              }, [
                (!messages.value.length)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_7, " Pergunte algo sobre os documentos do seu órgão. Ex: \"quais ofícios sobre reforma escolar estão pendentes?\" "))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messages.value, (message, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: _normalizeClass(["ai-assistant-widget__message", message.role])
                  }, [
                    _createElementVNode("p", null, _toDisplayString(message.text), 1),
                    (message.sources?.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(message.sources, (source) => {
                            return (_openBlock(), _createBlock(_component_RouterLink, {
                              key: source.id,
                              to: { name: 'admin.documents.show', params: { id: source.id } },
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (isOpen.value = false))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" #" + _toDisplayString(source.number) + " — " + _toDisplayString(source.title), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ], 2))
                }), 128)),
                (isAsking.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createVNode(SpinnerLoaderButton, {
                        isButton: false,
                        height: 22
                      })
                    ]))
                  : _createCommentVNode("", true)
              ], 512),
              _createElementVNode("form", {
                class: "ai-assistant-widget__input",
                onSubmit: _withModifiers(ask, ["prevent"])
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((question).value = $event)),
                  placeholder: "Digite sua pergunta...",
                  disabled: isAsking.value
                }, null, 8, _hoisted_10), [
                  [_vModelText, question.value]
                ]),
                _createElementVNode("button", {
                  type: "submit",
                  disabled: !question.value.trim() || isAsking.value || (!!aiUsage.value && aiUsage.value.remaining <= 0)
                }, _hoisted_13, 8, _hoisted_11)
              ], 32)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          type: "button",
          class: "ai-assistant-widget__toggle",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (isOpen.value = !isOpen.value))
        }, [
          (!isOpen.value)
            ? (_openBlock(), _createElementBlock("svg", _hoisted_14, _hoisted_17))
            : (_openBlock(), _createElementBlock("svg", _hoisted_18, _hoisted_20))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})